import API_ROUTES from "src/constants/apiRoutes";
import axios from "../api/axios-instance";

export const notificationsService = {
  getCount: () => axios.get(`${API_ROUTES.NOTIFICATIONS.COUNT}?checked=0`),
  getAll: (checked: boolean) =>
    axios.get(`${API_ROUTES.NOTIFICATIONS.GET_ALL}${checked ? "" : "?checked=0"}`),
  markAsChecked: (ids: number[]) => axios.patch(`${API_ROUTES.NOTIFICATIONS.CHECK}`, { ids }),
};
